import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { OfferSession } from 'app/shared/models/class/session/session';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SessionService } from 'app/shared/services/session/session.service';

@Component({
  selector: 'app-session-table',
  templateUrl: './session-table.component.html',
  styleUrls: ['./session-table.component.scss']
})
export class SessionTableComponent implements OnInit {

  @Input() set sessions(value: OfferSession[]) {
    this.initComponent(value);
  }

  @Output() addSession = new EventEmitter<boolean>();
  @Output() sessionSelected = new EventEmitter<OfferSession>();

  displayedColumns: string[] = ['label', 'startDate', 'endDate', 'quantity', 'isActive', 'edit'];
  dataSource: MatTableDataSource<OfferSession>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  constructor(
    private sessionService: SessionService,
    private faIconService: FaiconService,

  ) { }

  ngOnInit(): void { }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  isActivatedOrDeactivated(session: OfferSession): void {
    this.sessionService.activateOrDeactivateSessionOffer(session.sessionKey, !session.isActive).subscribe({
      next: () => this.addSession.emit(false)
    });
  }

  editSession(session: OfferSession): void {
    this.addSession.emit(true);
    this.sessionSelected.emit(session);
  }

  private initComponent(sessions: OfferSession[]): void {
    this.dataSource = new MatTableDataSource<OfferSession>(sessions);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = sessions?.length;
  }

}
